import React from 'react';
import { useNavigate } from 'react-router-dom';

const Missing = () => {
  const navigate = useNavigate();

  return (
    <div className='container mx-auto p-4'>
      <div className='flex items-center justify-center h-96'>
        <div className='space-y-3'>
          <h1>Ooops page missing...</h1>
          <button onClick={() => navigate(-1)} className='bg-green-600 text-white px-5 py-2 rounded md hover:bg-green-500'>Go Back</button>
        </div>
      </div>
    </div>
  );
};

export default Missing;
